import { toastr } from 'react-redux-toastr';
import { handleException } from 'actions/exceptions';
import { ApiService } from '../../services';

export const COMPLETE_BATCH_REQUEST = 'COMPLETE_BATCH_REQUEST';
export const COMPLETE_BATCH_SUCCESS = 'COMPLETE_BATCH_SUCCESS';
export const COMPLETE_BATCH_FAILURE = 'COMPLETE_BATCH_FAILURE';

function requestCompleteBatch() {
  return {
    type: COMPLETE_BATCH_REQUEST,
    isCompletingBatch: true
  };
}

function receiveCompleteBatch(batchCompleteSuccessful) {
  return {
    type: COMPLETE_BATCH_SUCCESS,
    isCompletingBatch: false,
    batchCompleteSuccessful
  };
}

function rejectCompleteBatch() {
  return {
    type: COMPLETE_BATCH_FAILURE,
    isCompletingBatch: false
  };
}

export function completeBatch(batchId, completeCallback, callbackParameters) {
  return (dispatch) => {
    dispatch(requestCompleteBatch());
    const promise = () => ApiService
      .getCompleteBatch(batchId)
      .then((response) => {
        if (response.data === true) {
          toastr.success('Batch Complete Successful', 'The batch has been completed successfully');
        } else {
          toastr.error('Batch Complete Failed', 'There was an error completing the batch.  Please try again');
        }
        dispatch(completeCallback(...callbackParameters || [batchId]));
        return dispatch(receiveCompleteBatch(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectCompleteBatch, true));
        }
      });
    return promise();
  };
}
